export const MenuResourcesDA = {
  home: "Forside",
  about: "Om Aida",
  books: "Bøger",
  podcast: "Podcast",
  lectures: "Foredrag",
  media: "Medier",
  courses: "Online kurser",
  contact: "Kontakt",
};

export const MenuResourcesEN = {
  home: "Home",
  about: "About Aida",
  books: "Books",
  podcast: "Podcast",
  lectures: "Lectures",
  media: "Media",
  courses: "Online Courses",
  contact: "Contact",
};

export const MenuResourcesDE = {
  home: "Startseite",
  about: "Über Aida",
  books: "Bücher",
  podcast: "Podcast",
  lectures: "Vorträge",
  media: "Medien",
  courses: "Online-Kurse",
  contact: "Kontakt",
};

export const MenuResourcesBS = {
  home: "Početna",
  about: "O Aidi",
  books: "Knjige",
  podcast: "Podkast",
  lectures: "Predavanja",
  media: "Mediji",
  courses: "Online kursevi",
  contact: "Kontakt",
};
